<template>
  <div class="category-selection">
    <img
      v-if="backgroundAssetType === 'image'"
      class="category-selection__background"
      :src="`${$store.state.assetsPath + $store.state.config.categorySelectionBackground}`"
    >
    <video
      v-if="backgroundAssetType === 'video'"
      class="category-selection__background"
      :src="`${$store.state.assetsPath + $store.state.config.categorySelectionBackground}`"
      autoplay
      muted
      loop 
    ></video>
    <transition name="fade" mode="out-in">
      <div class="wrapper" :key="showAustralia">
        <div v-if="showAustralia" class="region-selection">
          <div class="region-selection__map">
            <transition name="fade">
              <img :key="activeMap" :src="activeMap"/>
            </transition>
          </div>
          <div class="region-selection__message">Discover the best of Australia</div>
          <div
            class="region-selection__buttons region-selection__buttons--narrow"
            :style="hideButtons ? 'opacity: 0;' : ''"
          >
            <div class="region-selection__button touch animate-in " @click="navigateTo('sa')">
              <img src="../assets/MenuButton_SA.png">
              <span>South<br>Australia</span>
            </div>
            <div class="region-selection__button touch animate-in ">
              <img src="../assets/MenuButton_WA.png">
              <span>Western<br>Australia</span>
            </div>
            <div class="region-selection__button touch animate-in ">
              <img src="../assets/MenuButton_NT.png">
              <span>Northern<br>Territory</span>
            </div>
            <div class="region-selection__button touch animate-in ">
              <img src="../assets/MenuButton_QLD.png">
              <span>Queensland</span>
            </div>
            <div class="region-selection__button touch animate-in ">
              <img src="../assets/MenuButton_NSW.png">
              <span>New South<br>Wales</span>
            </div>
            <div class="region-selection__button touch animate-in ">
              <img src="../assets/MenuButton_VIC.png">
              <span>Victoria</span>
            </div>
            <div class="region-selection__button touch animate-in ">
              <img src="../assets/MenuButton_TAS.png">
              <span>Tasmania</span>
            </div>
            <div class="region-selection__button touch animate-in ">
              <img src="../assets/MenuButton_ACT.jpeg">
              <span>Australian Capital<br>Territory</span>
            </div>
          </div>
          <div class="region-selection__touch-prompt">
            <!-- <img src="../assets/touch-prompt.png"> -->
          </div>      
        </div>
        <div v-else class="category-selection__container">
          <div class="region-selection__map">
            <transition name="fade">
              <img :key="activeStateMap" :src="activeStateMap"/>
            </transition>
          </div>
          <div class="category-selection__welcome">
            <h1 class="welcome-text">Explore the regions of South Australia</h1>
          </div>
          <div class="region-selection__buttons" :style="hideButtons ? 'opacity: 0;' : ''">
            <!-- <div
              v-for="category in categories"
              class="category-selection__category touch animate-in "
              :key="category._id"
              @click="navigateToCategory(category)"
            >
              <div class="category-selection__category-inner">
                <div v-if="category.buttonBackground" class="category-selection__bg">
                  <img :src="assetsPath + category.buttonBackground.asset.path">
                </div>
                <div class="category-selection__label" v-html="category.label[language.code]"></div>
              </div>
            </div>
          </div> -->
          <div 
            v-for="category in categories"
            class="region-selection__button touch animate-in "
            :key="category._id"
            @click="navigateToCategory(category)">
              <img :src="assetsPath + category.buttonBackground.asset.path">
              <span v-html="category.label[language.code]"></span>
            </div>
          </div>
          <div class="region-selection__touch-prompt">
            <!-- <img src="../assets/touch-prompt.png"> -->
          </div>     
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      activeMap: require('../assets/AustraliaMap_Base.png'),
      hideButtons: false,
      maps: {
        base: require('../assets/AustraliaMap_Base.png'),
        sa: require('../assets/AustraliaMap_SA.png')
      },
      activeStateMap: require('../assets/SouthAustraliaMap_Base.png'),
      stateMaps: {
        base: require('../assets/SouthAustraliaMap_Base.png'),
        ki: require('../assets/SouthAustraliaMap_KI.png')
      },
      showAustralia: true
    }
  },

  computed: {
    assetsPath () {
      return this.$store.state.assetsPath
    },

    backgroundAssetType () {
      if (this.$store.state.config.categorySelectionBackground.split('.').pop() === 'mp4') {
        return 'video'
      } else {
        return 'image'
      }
    },

    categories () {
      return this.$store.getters.navigation
    },

    language () {
      return this.$store.getters.language
    },
    
    pages () {
      return this.$store.state.pages
    }
  },

  created () {
    if (this.$route.query.region) {
      this.showAustralia = false
    }
  },

  mounted () {
    let els = document.querySelectorAll('.animate-in')
    console.log(els)
    els.forEach((el, i) => {
      setTimeout(() => {
        el.classList.add('animate-in-do')
        // el.style.cssText = 'animation-delay:' + 200 * i + 'ms;'
        setTimeout(() => {
          el.classList.add('glow-pulse')
        }, 3000)
      }, 150 * i)
    })
  },

  methods: {
    ...mapActions([
      'activateCategoryById'
    ]),

    navigateTo (region) {
      setTimeout(() => {
        this.hideButtons = true
        setTimeout(() => {
          this.activeMap = this.maps[region]
          setTimeout(() => {
            this.showAustralia = false       
            setTimeout(() => {
              this.hideButtons = false
              let els = document.querySelectorAll('.animate-in-do')
              els.forEach(el => {
                el.classList.remove('animate-in-do')
              })     
              setTimeout(() => {
                let els = document.querySelectorAll('.animate-in')
                els.forEach((el, i) => {
                  setTimeout(() => {
                    el.classList.add('animate-in-do')
                    setTimeout(() => {
                      el.classList.add('glow-pulse')
                    }, 3000)
                    // el.style.cssText = 'animation-delay:' + 200 * i + 'ms;'
                  }, 150 * i)
                })        
              }, 400)
            }, 600)
          }, 2000)
        }, 600)
      }, 300)
    }, 

    navigateToCategory(category) {
      setTimeout(() => {
        this.hideButtons = true
        setTimeout(() => {
          this.activeStateMap = this.stateMaps.ki
          setTimeout(() => {
          if (category.customRoute) {
            this.$router.push(category.customRoute)
            } else {

              const defaultChild = _.find(this.pages, page => {
                return page._id === category.defaultChildId
              })

              if (defaultChild) {
                this.$router.push(`/category/${category._id}/page/${defaultChild._id}`)
              } else {
                this.$router.push(`/category/${category._id}/page/${category.children[0].pageId}`)
              }
            }
          }, 2000)
        }, 1000)
      }, 600)
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";

.category-selection {
  align-items: flex-end;
  background-position: 50%;
  background-size: cover;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  &__background {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;

    image,
    video {
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }

  &__container {
    background: rgba($black, 0);
    display: flex;
    flex-direction: column;
    margin: 0 0 6rem;
    padding: 0;
    width: 145.5rem;
  }

  &__categories {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 2rem;
    grid-row-gap: 2rem;
    height: 20.1rem;
  }

  &__welcome {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .welcome-text {
      font-size: 3.2rem;
      font-weight: 700;
      letter-spacing: .5rem;
      margin: 1em;
      opacity: .6;
      text-align: center;
      text-transform: uppercase;
    }
  }

  &__category {
    background: #000;
    border-radius: .5rem;
    box-shadow: $tag-box-shadow;
    overflow: hidden;
    width: 22.5rem;
  }

  &__category-inner {
    align-items: center;
    display: flex;
    font-size: 1.3rem;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    letter-spacing: .2rem;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    width: 100%;
  }

  &__bg {
    height: 100%;
    opacity: .8;
    position: absolute;
    width: 100%;

    img {
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }

  &__label {
    text-shadow: 0 0px 5px rgba(0, 0, 0, 0.5);
    z-index: 10;
  }

  &__map {
    display: flex;
    justify-content: center;
    height: 44rem;
    margin: 0 0 5rem;
    z-index: 1;
    position: relative;

    img {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      object-fit: contain;
      width: 100%;
    }
  }

  &__touch-prompt {
    display: flex;
    justify-content: center;
    margin-top: 3rem;

    img {
      animation: pulse 4s ease-in-out .6s infinite;
      height: 8.5rem;
    }
  }
}

.region-selection {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-evenly;
  width: 100%;
  
  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
    z-index: -1;
  }

  &__map {
    position: relative;
    width: 63rem;
    height: 60rem;

    img {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  &__message {
    font-size: 3.2rem;
    font-weight: 700;
    letter-spacing: .5rem;
    opacity: 0.8;
    text-align: center;
    text-transform: uppercase;      
  }

  &__buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 80vw;
    transition: opacity 0.6s;

    &--narrow {
      max-width: 60vw;
    }
  }

  &__button {
    align-items: center;
    border-radius: .5rem;
    box-shadow:rgba(#000, 0.6) 0.05rem 0.1rem 0.2rem;
    display: flex;
    height: 9rem;
    justify-content: center;
    margin: 0 1rem 2rem;
    // overflow: hidden;
    position: relative;
    transition: transform 0.3s, border 0.3s;
    width: 22rem;
    pointer-events: all;

    &:focus,
    &:active {
      transform: translateY(0.1rem);
      border: 0.2rem solid rgba(255, 255, 255, 1);
    }

    img {
      border-radius: .5rem;
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      object-fit: cover;
      width: 100%;
    }

    span {
      font-size: 1.3rem;
      font-weight: 400;
      letter-spacing: .2rem;
      line-height: 1.1;
      position: relative;
      text-align: center;  
      text-shadow: 0 0 0.5rem rgba(0, 0, 0, 1);
      text-transform: uppercase;    
    }
  }

  &__touch-prompt {
    img {
      animation: pulse 4s ease-in-out .6s infinite;
      height: 7rem;
      width: 6.5rem;
      object-fit: contain;
    }
  }    
}

.fade {
  &-enter-active, &-leave-active {
    transition: opacity 0.6s;
  }

  &-enter, &-leave-to {
    opacity: 0;
  }
} 

@keyframes pulse {
  0% {  transform: scale(1); opacity: 0.7; }
  5% { transform: scale(1.1); opacity: 1; }
  10% { transform: scale(1);}
  15% { transform: scale(1.1); opacity: 1; }
  20% { transform: scale(1); opacity: 0.7; }
  100% { transform: scale(1); opacity: 0.7; }
}

@keyframes glow {
  0% { 
    border: 0.2rem solid rgba(#fff, 0);
    // opacity: 0.9;
    // box-shadow: 0 0 2rem 0.5rem rgba(#ffea77, 0.5);
  }
  20% { 
    border: 0.2rem solid rgba(255, 255, 255, 1);
    // opacity: 1;
    // box-shadow: 0 0 2rem 0rem rgba(#ffea77, 0.5); 
  }
  40%, 100% { 
    border: 0.2rem solid rgba(#fff, 0);
    // opacity: 0.9;
    // box-shadow: 0 0 2rem 0.5rem rgba(#ffea77, 0.5);
  }
}

.glow-pulse {
  position: relative;

  &::before {
    content: "";
    position: absolute;
    border-radius: .8rem;
    top: -0.2rem;
    left: -0.2rem;
    height: 100%;
    width: 100%;
    animation: glow 4s infinite;
    z-index: 99;
    animation-delay: inherit;
  }
}

.category-selection__container, .region-selection {
  padding-top: 5rem;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-evenly;
  width: 100%;
}

.animate-in {
  opacity: 0;
  transform: translateY(2rem);
}

.animate-in-do {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.6s, transform 0.6s cubic-bezier(0.33, 1, 0.68, 1);
}
</style>